const columnWidths: Record<string, Record<string, number>> = {
    hr: {
        checkbox: 40,
        internalAppId: 70,
        mainPhoto: 80,
        internalId: 120,
        propertyService: 150,
        propertyStatus: 150,
        propertyType: 150,
        propertySubType: 150,
        country: 120,
        county: 150,
        city: 150,
        widerArea: 150,
        quarter: 150,
        street: 150,
        streetNumber: 100,
        owner: 150,
        price: 120,
        priceM2: 150,
        area: 150,
        floorNo: 100,
        roomsNo: 80,
        bedroomsNo: 150,
        primaryAgent: 150,
        agentMobile: 130,
        maxConstructionArea: 150,
        distanceSea: 200,
        areaGarden: 200,
        plotArea: 120,
        propertyHeating: 150,
        propertyWebsite: 50,
        propertyEquipment: 50,
        constructionYear: 150,
        availableFromDate: 150,
        propertySupplySource: 130,
        created: 130,
        contractNo: 120,
        ownerPhoneNumber1: 150,
        ownerPhoneNumber2: 150,
        project: 150,
        propertyLabel: 120,
        actions: 100,
    },
    // Add locale overrides below — only specify columns that differ from hr.
    sl: {
        mainPhoto: 100,
        streetNumber: 120,
        price: 100,
        bedroomsNo: 100,
        agentMobile: 200,
        maxConstructionArea: 200,
        distanceSea: 220,
        areaGarden: 150,
        propertyWebsite: 120,
        propertyEquipment: 80,
        constructionYear: 130,
        availableFromDate: 130,
        contractNo: 150,
        propertyLabel: 150,
    },
    en: {
        streetNumber: 130,
        bedroomsNo: 120,
        agentMobile: 150,
        areaGarden: 150,
        maxConstructionArea: 200,
        distanceSea: 220,
        propertyWebsite: 80,
        plotArea: 100,
        propertyHeating: 120,
        propertyEquipment: 80,
        constructionYear: 170,
        availableFromDate: 100,
        created: 120,
        contractNo: 150,
        propertyLabel: 300,
    },
    de: {},
    it: {},
}

export default columnWidths
